import React, { useState, useEffect, useRef, useCallback } from "react";
import { Accordion, ToastContainer } from "react-bootstrap";
import "./OrderDetails.css";
import OrderDetailsModal from "../OrderDetailsModal/OrderDetailsModal";
import OrderTableDialog from "../components/OrderTableDialog";
import jwtDecode from "jwt-decode";
import axios from "axios";
import { getPercentageOrAmount } from "../../../utils/getPercentageOrAmount.js";
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import { toast } from "react-toastify";
import { rest } from "lodash";

const OrderDetails = ({
  title,
  restaurant,
  // onUpdateServiceCharge,
  selectedTable,
  setSelectedTable,
  selectedOkTable,
  setIsToggleOn,
  isToggleOn,
  DeliverySelfCollectionState,
  isServiceChargeEnabled: parentIsServiceChargeEnabled,
  handleServiceChargeToggle: parentHandleServiceChargeToggle
}) => {
  const [modalShow, setModalShow] = useState(false);
  const [tableModalShow, setTableModalShow] = useState(false);
  const [clickedRestaurant, setClickedRestaurant] = useState("");
  const [orderType, setOrderType] = useState("");
  const [cartData, setCartData] = useState([]);
  const [selectOk, setselecteOk] = useState([]);
  const [totalSd, setTotalSd] = useState(0);
  const [totalVat, setTotalVat] = useState(0);
  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [serviceCharge, setServiceCharge] = useState(0);
  const [serviceChargeVat, setServiceChargeVat] = useState(0);
  // Use parent's service charge state if provided, otherwise use local state
  const [localIsServiceChargeEnabled, setLocalIsServiceChargeEnabled] = useState(true);
  const isServiceChargeEnabled = parentIsServiceChargeEnabled !== undefined ? parentIsServiceChargeEnabled : localIsServiceChargeEnabled;
  // const [isToggleOn, setIsToggleOn] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showCollectionTag, setShowCollectionTag] = useState(false);
  const [toggleStateForNotCollection, setToggleStateForNotCollection] = useState(false);
  const array = [];

  const handleShowTableModal = (restaurantId) => {
    setClickedRestaurant(restaurantId);
    setTableModalShow(true);
  };

  // const handleShowModal = (restaurantName, order) =>{
  //     setModalShow(true);
  //     setClickedRestaurant(restaurantName);
  //     setOrderType(order);
  // }

  useEffect(() => {
    selectedOkTable(selectOk);
  }, [selectOk]);

  useEffect(() => {
    const calculateTotals = () => {
      let totalBasePrice = 0;
      let fooditemVat = 0;
      let foodItemSd = 0;

      let totalAddonPrice = 0;
      let totalAddonSD = 0;
      let totalAddonVat = 0;

      let totalOptionPrice = 0;
      let totalOptionVat = 0;
      let totalOptionSD = 0;

      let totalSubOptionPrice = 0;
      let totalSubOptionSd = 0;
      let totalSubOptionVat = 0;

      restaurant.subOrders
        .filter((subOrder) => subOrder.orderTypeName === title)
        .forEach((subOrder) => {
          // Calculating Total price, vat and sd of foodItem
          subOrder.itemDetails.forEach((item) => {
            totalBasePrice =
              totalBasePrice + item.basePrice * item.foodItemQuantity;
            fooditemVat += item.vatInAmount * item.foodItemQuantity;
            foodItemSd += item.sdInAmount * item.foodItemQuantity;

            // Calculating Total price, vat and sd of AddOn
            item.addOns.forEach((addOn) => {
              totalAddonPrice += addOn.addOnBasePrice * addOn.addOnQuantity;
              totalAddonVat += addOn.addOnVatAmount * addOn.addOnQuantity;
              totalAddonSD += addOn.addOnSdAmount * addOn.addOnQuantity;

              // Calculating Total price, vat and sd of Option
              addOn.options.forEach((option) => {
                totalOptionPrice +=
                  option.optionBasePrice * option.optionQuantity;
                totalOptionVat +=
                  option.optionVatAmount * option.optionQuantity;
                totalOptionSD += option.optionSdAmount * option.optionQuantity;

                // Calculating Total price, vat and sd of SubOption
                option.subOptions.forEach((subOption) => {
                  totalSubOptionPrice += subOption.subOptionBasePrice * subOption.subOptionQuantity;
                  totalSubOptionSd += subOption.subOptionSdAmount * subOption.subOptionQuantity;
                  totalSubOptionVat += subOption.subOptionVatAmount * subOption.subOptionQuantity;
                });
              });
            });
          });
        });

      const totalVatAmount =
        fooditemVat + totalAddonVat + totalOptionVat + totalSubOptionVat;
      const totalSdAmount =
        foodItemSd + totalAddonSD + totalOptionSD + totalSubOptionSd;

      setTotalVat(totalVatAmount);
      setTotalSd(totalSdAmount);
      setSubTotalAmount(
        totalBasePrice +
        totalAddonPrice +
        totalOptionPrice +
        totalSubOptionPrice
      );
    };

    calculateTotals();
  }, [restaurant, title]);

  useEffect(() => {
    // Initialize service charge toggle based on isServiceChargeCom
    if (parentIsServiceChargeEnabled === undefined) {
      // Only initialize local state if parent state is not provided
      if (restaurant?.isServiceChargeCom === false) {
        setLocalIsServiceChargeEnabled(true); // Default ON when false
      } else if (restaurant?.isServiceChargeCom === true) {
        setLocalIsServiceChargeEnabled(true); // Always ON when true
      }
    }
  }, [restaurant, parentIsServiceChargeEnabled]);

 
  useEffect(() => {

    if (title === "In-Store" && isServiceChargeEnabled) {
      const vatAmount = getPercentageOrAmount(
        subTotalAmount,
        restaurant?.serviceCharge,
        "amount"
      );
 
      setServiceCharge(vatAmount);
      
      // Calculate Service Charge VAT (20%)
      const serviceChargeVatAmount = getPercentageOrAmount(
        vatAmount,
        20,
        "amount"
      );
    
      setServiceChargeVat(serviceChargeVatAmount);
      // onUpdateServiceCharge(vatAmount);
    } else {
     
      setServiceCharge(0);
      setServiceChargeVat(0);
      // onUpdateServiceCharge(0);
    }
  }, [restaurant, subTotalAmount, isServiceChargeEnabled, title]);

  const Total = () => {
    return (subTotalAmount + totalSd + totalVat + 0 + serviceCharge + serviceChargeVat);
  };

  const TotalAfterCredit = () => {
    if (subTotalAmount + totalSd + totalVat + 0 + serviceCharge + serviceChargeVat >= restaurant?.minimumOrderPriceToGiveCredit) {
      return (subTotalAmount + totalSd + totalVat + 0 + serviceCharge + serviceChargeVat) - restaurant.creditLimitPerOrder;
    } else {
      return subTotalAmount + totalSd + totalVat + 0 + serviceCharge + serviceChargeVat;
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem("gotasteClienttoken");
    const decoded = jwtDecode(userId);

    const getCartData = async (userId) => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/Cart/GetCartDataByUserId?userId=${userId}`
        );
        setCartData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    getCartData(decoded.UserId);
  }, []);

  // useEffect(() => {
  //   restaurant.subOrders.forEach((subOrder) => {
  //     if (subOrder.orderTypeName === "Delivery") {
  //       // Check all items inside itemDetails
  //       const allItemsMatch = subOrder.itemDetails.every(
  //         (item) => item.isDelivery === true && item.isCollectionOnly === true
  //       );

  //       // const allItemsMatch = true;

  //       setIsDisabled(allItemsMatch); // Disable only if all items match
  //       if (allItemsMatch) {
  //         setIsToggleOn(true); // Force ON when disabled
  //         toast.info("Items for self-collection");
  //       }
  //     }
  //   });
  // }, [restaurant]);

  const notificationShown = useRef(false);
  const ShowDeliveryNotification = (subOrder) => {
    const allItemsMatch = subOrder.itemDetails.every(
      (item) =>
        item.isDelivery === true &&
        item.isDeliveryOff === false &&
        item.isCollectionOnly === true
    );

    if (allItemsMatch) {
      if (!isDisabled) setIsDisabled(true);
      if (!isToggleOn) setIsToggleOn(true);

      if (!notificationShown.current) {
        toast.info("Items for self-collection");
        notificationShown.current = true;
      }
    }
  };

  useEffect(() => {
    if (restaurant !== null) {
      restaurant?.subOrders
        .filter(subOrder => subOrder.orderTypeName === "Delivery")
        .forEach(ShowDeliveryNotification);
    }
  }, [restaurant]);

  const [storedSwitchedItems, setStoredSwitchedItems] = useState([]);

  const handleToggle = (usedFor, subOrder) => {
    if (usedFor === "NotCollection") {
      DeliverySelfCollectionState(subOrder);

      setStoredSwitchedItems(prevItems => {
        const existingItem = prevItems.find(item => item.subOrderId === subOrder.subOrderId);

        if (existingItem) {
          return prevItems.map(item =>
            item.subOrderId === subOrder.subOrderId ? { ...item, active: !item.active } : item
          );
        } else {
          return [...prevItems, { subOrderId: subOrder.subOrderId, active: true }];
        }
      });
    }
  };

  const handleServiceChargeToggle = useCallback(() => {
    // Only allow toggle if isServiceChargeCom is false
    if (restaurant?.isServiceChargeCom === false) {
      if (parentHandleServiceChargeToggle) {
        // Use parent handler if provided
        parentHandleServiceChargeToggle();
      } else {
        // Use local state if no parent handler
        setLocalIsServiceChargeEnabled(prevState => !prevState);
      }
    }
  }, [parentHandleServiceChargeToggle, restaurant, isServiceChargeEnabled]);

  // if (!isDisabled) {
  //   setIsToggleOn(!isToggleOn);
  // }

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#1890ff',
          ...theme.applyStyles('dark', {
            backgroundColor: '#177ddc',
          }),
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
      ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255,255,255,.35)',
      }),
    },
  }));

  return (
    <Accordion defaultActiveKey={null} className="parent-body-shadow">
      <Accordion.Item eventKey={`${1}`}>
        <Accordion.Header className="order-shadow">
          <ToastContainer />
          <div className="d-flex align-items-center">
            <div className="header-weight-bold">{title === "In-Store" ? "Dine-In" : title}</div>
            {title === "Delivery" && (
              <div className="d-flex align-items-center">
                <Tooltip title="Self-collection" arrow>
                  <span>
                    {restaurant?.subOrders?.filter((subOrder) => subOrder.orderTypeName === title)
                      .map((subOrder) => subOrder.itemDetails.map((item) => (
                        <>
                          {item.isDelivery === true && item.isCollectionOnly === true && item.isDeliveryOff === false && subOrder.orderTypeName !== "In-Store" ?
                            <AntSwitch
                              className="ms-2"
                              checked={isToggleOn}
                              disabled={true}
                              onClick={() => handleToggle("Collection", subOrder)}
                              inputProps={{ "aria-label": "ant design" }}
                            />
                            :
                            <AntSwitch
                              className="ms-2"
                              checked={storedSwitchedItems.some(item => item.subOrderId === subOrder.subOrderId && item.active)}
                              disabled={isDisabled}
                              onClick={() => handleToggle("NotCollection", subOrder)}
                              inputProps={{ "aria-label": "ant design" }}
                            />
                          }
                        </>
                      )
                      )
                      )
                    }
                  </span>
                </Tooltip>
                <span className="ms-2">Self-Collection</span>
              </div>
            )}

            {title === "In-Store" && (
              <div
                className="ms-2 table-selection"
                // onClick={() => handleShowTableModal(restaurant?.restaurantId)}
                onClick={() =>
                  handleShowTableModal(restaurant?.cartRestaurantId)
                }
              >
                {selectOk?.tableName ? selectOk?.tableName :
                  selectedTable?.tableName ? selectedTable?.tableName : "Select Table"}
              </div>
            )}
          </div>
        </Accordion.Header>

        <Accordion.Body className="d-block px-2">
          <div>
            <div className="order-details-wrapper">
              <div></div>
              {/* Header */}
              <div className="d-flex">
                <div className="text-bold text-center margin-r">Base price</div>
                <div className="text-bold text-center">Total</div>
              </div>
            </div>
            {/* Header end  */}
            {restaurant.subOrders
              .filter((subOrder) => subOrder.orderTypeName === title)
              .map((subOrder) =>
                subOrder.itemDetails.map((item) => (
                  <div className="order-details-wrapper mb-4">
                    <div>
                      <div className="food-name text-small">
                        <span>{item.foodItemName}</span>
                        {/* {
                          ((subOrder.orderTypeName === "Delivery" && item.isDelivery === true && item.isCollectionOnly === true) || isToggleOn) && <span className="self-collection-tag">(Collection)</span>
                        } */}
                        {(item.isDelivery === true && item.isCollectionOnly === true && item.isDeliveryOff === false && subOrder.orderTypeName !== "In-Store") &&
                          <span className="self-collection-tag">(Collection)</span>
                        }

                        {toggleStateForNotCollection && subOrder.orderTypeName !== "In-Store" &&
                          <span className="self-collection-tag">(Collection)</span>
                        }

                      </div>{" "}
                      {/* FoodItem name */}
                      {/*Option Name*/}
                      {item.addOns.map((addon) => (
                        <div
                          key={addon.addOnId}
                          className="sub-options sub-options-color my-1 text-small"
                        >
                          {addon.addOnName}
                          {addon.options.map((option) => (
                            <div
                              key={option.optionId}
                              className="sub-options sub-options-color my-1 text-small"
                            >
                              {option.optionName}
                              {/* Sub-Option Name */}
                              {option.subOptions.map((subOption) => (
                                <div
                                  key={subOption.subOptionId}
                                  className="sub-options sub-options-margin text-small"
                                >
                                  <span>{subOption.subOptionName}</span>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>

                    <div className="d-flex">
                      <div className="base-price-container text-end">
                        <div className="text-black text-small">
                          {item.foodItemQuantity} * &#163;{item.basePrice}
                        </div>{" "}
                        {/* quantit and item base price */}
                        {/*Option BasePrice and Quantity*/}
                        <div className="my-1 text-black text-small">
                          {item.addOns.map((addon) => (
                            <div className="sub-options sub-options-color ms-2 text-small">
                              <span>
                                {addon.addOnQuantity} * &#163;
                                {addon.addOnBasePrice}
                              </span>
                              {addon.options.map((option) => (
                                <div className="sub-options sub-options-color my-1 text-small">
                                  <span>
                                    {option.optionQuantity} * &#163;
                                    {option.optionBasePrice}
                                  </span>
                                  {/*Sub-Option BasePrice and Quantity*/}

                                  {option.subOptions.map((subOption) => (
                                    <div className="text-black text-small">
                                      {" "}
                                      {/*No quantity found*/}
                                      <span>
                                        {subOption.subOptionQuantity} * &#163;{subOption.subOptionBasePrice}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="text-end">
                        <div className="text-black text-small">
                          £{(item.foodItemQuantity * item.basePrice).toFixed(2)}
                        </div>{" "}
                        {/* item total price */}
                        <div className="my-1 text-black text-small">
                          {/* Option Total Price */}
                          {item.addOns.map((addon) => (
                            <div className="sub-options sub-options-color ms-2 text-small">
                              <span>
                                £
                                {(
                                  addon.addOnQuantity * addon.addOnBasePrice
                                ).toFixed(2)}
                              </span>
                              {addon.options.map((option) => (
                                <div className="sub-options sub-options-color my-1 text-small">
                                  <span>
                                    £
                                    {(
                                      option.optionQuantity *
                                      option.optionBasePrice
                                    ).toFixed(2)}
                                  </span>
                                  {/*Sub-Option Total Price*/}
                                  <div className="text-black text-small">
                                    {option.subOptions.map((subOption) => (
                                      <span>
                                        £
                                        {subOption.subOptionTotalPrice.toFixed(
                                          2
                                        )}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
          </div>
          <hr />
          <div className="total-price">
            <div>
              <div className="my-1 text-small">Sub total</div>
              <div className="my-1 text-small">Total SD</div>
              <div className="my-1 text-small d-flex align-items-center justify-content-between">
                <span>Service charge ({restaurant.serviceCharge}%)</span>
                {title === "In-Store" && restaurant?.isServiceChargeCom === false && (
                  <Tooltip title={restaurant?.isServiceChargeCom === true ? "Service charge is mandatory" : "Toggle service charge"} arrow>
                    <span>
                      <AntSwitch
                        checked={isServiceChargeEnabled}
                        disabled={restaurant?.isServiceChargeCom === true}
                        onChange={handleServiceChargeToggle}
                        inputProps={{ "aria-label": "service charge toggle" }}
                      />
                    </span>
                  </Tooltip>
                )}
              </div>
              {title === "In-Store" && isServiceChargeEnabled && serviceCharge > 0 && (
                <div className="my-1 text-small">Service Charge VAT (20%)</div>
              )}
              <div className="my-1 text-small">Total VAT</div>
              <div className="my-1 text-small">Total</div>
              <div className="my-1 text-small">Total Credit</div>
            </div>

            <div className="align-right">
              <div className="my-1 text-small">
                &#163;{subTotalAmount.toFixed(2)}
              </div>
              <div
                className="my-1 text-small text-primary text-decoration-underline text-cursor-pointer"
                onClick={() => setModalShow(true)}
              >
                &#163;{totalSd.toFixed(2)}
              </div>
              <div className="my-1 text-small">£{serviceCharge.toFixed(2)}</div>
              {title === "In-Store" && isServiceChargeEnabled && serviceCharge > 0 && (
                <div className="my-1 text-small">£{serviceChargeVat.toFixed(2)}</div>
              )}
              <div
                className="my-1 text-small text-primary text-decoration-underline text-cursor-pointer"
                onClick={() => setModalShow(true)}
              >
                &#163;{totalVat.toFixed(2)}
              </div>

              <div className="my-1 text-small">&#163;{Total().toFixed(2)}</div>
              <div className="my-1 text-small">
                {restaurant.restaurantCredit !== 0 &&
                  <span>-</span>
                }
                {Total().toFixed(2) >= restaurant.minimumOrderPriceToGiveCredit && restaurant.restaurantCredit !==0 ? restaurant.creditLimitPerOrder : "N/A"}
              </div>
            </div>
          </div>
          <hr />
          <div className="d-flex align-items-center justify-content-between">
            <div className="my-1">Total Payable</div>
            <div className="my-1 text-small">&#163;{TotalAfterCredit().toFixed(2)}</div>
          </div>

          <OrderTableDialog
            show={tableModalShow}
            onHide={() => setTableModalShow(false)}
            restaurantId={clickedRestaurant}
            preSelectedTable={selectedTable}
            setParentSelectedTable={setSelectedTable}
            SetselecteOk={setselecteOk}
            selectOk={selectOk}
          />

          <OrderDetailsModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            userCartData={cartData?.filter(c => c.cartRestaurantId === restaurant?.cartRestaurantId) || []}
            setParentSelectedTable={setSelectedTable}
            serviceChargeEnabledByRestaurant={{ [restaurant?.cartRestaurantId]: isServiceChargeEnabled }}
            handleServiceChargeToggle={() => handleServiceChargeToggle(restaurant?.cartRestaurantId)}
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default OrderDetails;
